import type { TError, TInstructor } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';

export interface TMembersInstructorsResponse {
  items: TInstructor[];
  meta: {
    total: number;
  };
}

export const useGetMembersInstructorsQueryKey = () => [ENTITY, 'instructors'];

export const useGetMembersInstructors = () => {
  return useQuery<TMembersInstructorsResponse, TError>({
    queryKey: useGetMembersInstructorsQueryKey(),
    queryFn: async () => {
      const res = await axios.get<TMembersInstructorsResponse>('/community-hub/instructors');
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
